import React from "react";
import FormatedDate from "./FormatedDate";
import Weathericon from "./Weathericon";
import WeatherTemp from "./WeatherTemp";
 
export default function WeatherInfo(props) {
    return (
      <div className="weatherinfo">
        <h1>{props.data.city}</h1>
        <ul>
          <li>
            <FormatedDate date={props.data.date} />
          </li>
          <li className="text-capitalize">{props.data.description}</li>
        </ul>

        <div className="row mt-3">
          <div className="col-6">
            <div className="d-flex">
              <div>
                <Weathericon
                  code={props.data.icon}
                  alt={props.data.description}
                />
              </div>
             
              <WeatherTemp celsius={props.data.temperature}/>
            </div>
          </div>

          <div className="col-6">
            <ul>
              <li>Wind:{Math.round(props.data.wind)}KMPH</li>
              <li>Humudity:{props.data.humidity}%</li>
            </ul>
          </div>
        </div>
      </div>
    );
    
}